import styled from 'styled-components'

import Field from 'components/Form/components/Field'

export const OrganisationReportingDateRangeFieldStyled = styled(Field)`
  /* padding: 0; messing up default form layout */
`
